<template>
    <transition name="fade" @after-enter="afterEnter">
        <div class="popup" style="background-image: url('static/img/main/point3/popup/bg.png');" ref="popup">
            <div class="popup-bg delay3"></div>
            <div class="popup-inner ">
                <a href="#" class="close" @click.prevent="closePopup"></a>
                <div class="left delay6">
                    <div class="quotes quotes-right">
                    <span class="text">
                        В пригороде Швебиш-Гмюнда есть сказочный сад. Тот самый, где вот уже почти 100 лет создают истинно натуральную косметику
                    </span>
                    </div>
                    <div class="info">
                    <span class="point">
                        <span class="text">
                            Швeбиш-Гмюнд, Германия
                        </span>
                    </span>
                        <h3 class="head">
                            Сказочный сад <br> в Швeбиш-Гмюнд
                        </h3>
                        <span class="desc">
                            Weleda была одной из первых косметических марок, которая взялась выращивать ботаническое сырье в собственных садах. Сегодня их у компании восемь, и самый большой находится в городке Швебиш-Гмюнд, что в 50 километрах от Штутгарта. Как и другие, этот сад биодинамический: в нем не используются инсектициды и искусственные удобрения, хозяйство ведется в соответствии с ритмами природы (например, фазами Луны), а газонокосильщиками «работают» овцы и утки, свободно разгуливающие по саду. А неподалеку от сада специалисты Weleda применяют уникальные знания и технологии на практике, ведь именно здесь находится производство косметики.
                        </span>
                    </div>
                </div>
                <div class="right delay9">
                    <div class="popup-products">
                        <div class="info">
                            <h4 class="head">
                                Универсальный питательный крем SKINFOOD
                            </h4>
                            <span class="desc">
                            Крем с насыщенной текстурой и 100% натуральными ингредиентами.
                                Один из первых продуктов Weleda, который до сих пор на пике популярности и востребован среди звезд и моделей в Англии и США.

                        </span>
                            <a href="https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%BD%D0%B0%D1%82%D1%83%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D1%81%D0%BC%D0%B5%D1%82%D0%B8%D0%BA%D0%B0-weleda/%D1%84%D0%B8%D0%BB%D0%BE%D1%81%D0%BE%D1%84%D0%B8%D1%8F-%D1%83%D1%85%D0%BE%D0%B4%D0%B0/%D0%BA%D0%B0%D0%BA-%D0%BF%D0%B8%D1%82%D0%B0%D0%B5%D1%82%D1%81%D1%8F-%D0%B2%D0%B0%D1%88%D0%B0-%D0%BA%D0%BE%D0%B6%D0%B0?utm_source=afisha&utm_medium=card&utm_term=germany&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="btn" @click="gaEvents('places','click','know more ')">
                                Подробнее
                            </a>
                        </div>
                        <div class="img img-popup3">
                            <img src="static/img/main/point3/popup/product.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {TweenMax} from 'gsap';
    import  popupMix from '@/components/pages/popups/popup_mix.vue';

    export default {
        name: 'popup3',
        mixins: [popupMix],
    }
</script>



// WEBPACK FOOTER //
// popup3.vue?4a54cd3b